<template>
  <vs-row>
    <vs-col vs-w="9">
      <vs-row>
        <vs-col>
          <vx-card :title="$t('view_referral.block.information.title')">
            <vs-row vs-justify="center" vs-align="center">
              <vs-col vs-w="12" class="py-10">
                <vs-row>
                  <vs-col>
                    <div class="vx-card__title mb-6"><h4 class="">{{ $t('view_referral.block.information.claimant.title') }}</h4></div>
                  </vs-col>
                </vs-row>
                <vs-row v-if="behalfOfTitle">
                  <vs-col>
                    <vs-row>
                      <vs-col vs-lg="6" vs-sm="12" class="px-5 py-2">
                        <vs-row>
                          <vs-col vs-w="3">
                            <span>{{ behalfOfTitle }}</span>
                          </vs-col>
                          <vs-col vs-w="9">
                            <strong>{{ behalfOf }}</strong>
                          </vs-col>
                        </vs-row>
                      </vs-col>
                    </vs-row>
                  </vs-col>
                </vs-row>
                <vs-row>
                  <vs-col>
                    <vs-row>
                      <vs-col vs-lg="6" vs-sm="12" class="px-5 py-2">
                        <vs-row>
                          <vs-col vs-w="3">
                            <span>{{ $t('view_referral.block.information.claimant.fields.firstname') }}</span>
                          </vs-col>
                          <vs-col vs-w="9">
                            <strong>{{ referralResource.$getEmbedded('referral-claimant').firstname }}</strong>
                          </vs-col>
                        </vs-row>
                      </vs-col>
                      <vs-col vs-lg="6" vs-sm="12" class="px-5 py-2">
                        <vs-row>
                          <vs-col vs-w="3">
                            <span>{{ $t('view_referral.block.information.claimant.fields.lastname') }}</span>
                          </vs-col>
                          <vs-col vs-w="9">
                            <strong>{{ referralResource.$getEmbedded('referral-claimant').lastname }}</strong>
                          </vs-col>
                        </vs-row>
                      </vs-col>
                      <vs-col vs-lg="6" vs-sm="12" :class="'px-5 py-2'">
                        <vs-row>
                          <vs-col vs-w="3">
                            <span>{{ $t('view_referral.block.information.claimant.fields.email') }}</span>
                          </vs-col>
                          <vs-col vs-w="9">
                            <strong>{{ referralResource.$getEmbedded('referral-claimant').email }}</strong>
                          </vs-col>
                        </vs-row>
                      </vs-col>
                      <vs-col vs-lg="6" vs-sm="12" class="">
                      </vs-col>
                      <vs-col vs-lg="6" vs-sm="12" v-bind:class="{ 'overflow': 'scroll' }" class="px-5 py-2">
                        <vs-row>
                          <vs-col vs-w="3">
                            <span>{{businessUnitLabel ? businessUnitLabel : $t('view_referral.block.information.claimant.fields.businessUnit') }}</span>
                          </vs-col>
                          <vs-col vs-w="9">
                            <strong>{{
                                referralResource.$getEmbedded('referral-action').$hasEmbedded('business-unit') ? referralResource.$getEmbedded('referral-action').$getEmbedded('business-unit').name : 'None selected'
                              }}</strong>
                          </vs-col>
                        </vs-row>
                      </vs-col>
                      <vs-col vs-lg="6" vs-sm="12" class="px-5 py-2">
                        <vs-row>
                          <vs-col vs-w="3">
                            <span>{{ $t('view_referral.block.information.claimant.fields.profession') }}</span>
                          </vs-col>
                          <vs-col vs-lg="9">
                            <strong>{{
                                referralResource.$getEmbedded('referral-action').$hasEmbedded('profession') ? referralResource.$getEmbedded('referral-action').$getEmbedded('profession').name : 'None selected'
                              }}</strong>
                          </vs-col>
                        </vs-row>
                      </vs-col>
                      <vs-col vs-lg="6" vs-sm="12" class="px-5 py-2">
                        <vs-row>
                          <vs-col vs-w="3">
                            <span>{{ $t('view_referral.block.information.claimant.fields.language') }}</span>
                          </vs-col>
                          <vs-col vs-lg="9">
                            <strong>{{
                                referralResource.$getEmbedded('referral-claimant').language ? referralResource.$getEmbedded('referral-claimant').language : 'None selected'
                              }}</strong>
                          </vs-col>
                        </vs-row>
                      </vs-col>
                      <vs-col vs-lg="6" vs-sm="12" class="px-5 py-2">
                        <vs-row v-if="isCaseManagerTeamOn">
                          <vs-col vs-w="3">
                            <span>{{ hqTeamLabel }}</span>
                          </vs-col>
                          <vs-col vs-lg="9">
                            <strong>{{
                                referralResource.hqTeamName ? referralResource.hqTeamName : '--'
                              }}</strong>
                          </vs-col>
                        </vs-row>
                      </vs-col>
                    </vs-row>
                  </vs-col>
                </vs-row>
                <vs-row class="mt-10">
                  <vs-col>
                    <div class="vx-card__title mb-6"><h4 class="">{{ $t('view_referral.block.information.claim.title') }}</h4></div>
                  </vs-col>
                </vs-row>
                <vs-row>
                  <vs-col>
                    <vs-row>
                      <vs-col vs-lg="6" vs-sm="12" class="px-5 py-2">
                        <vs-row>
                          <vs-col vs-w="3">
                            <span>{{ userIdLabel }}</span>
                          </vs-col>
                          <vs-col vs-w="9">
                            <strong>{{ referral.$getEmbedded('referral-claim').claimNumber }}</strong>
                          </vs-col>
                        </vs-row>
                      </vs-col>
                      <vs-col vs-lg="6" vs-sm="12" class="px-5 py-2">
                        <vs-row  v-if="showPolicyNumberLabel">
                          <vs-col vs-w="3">
                            <span>{{ policyNumberLabel }}</span>
                          </vs-col>
                          <vs-col vs-w="9">
                            <strong>{{ referral.$getEmbedded('referral-claim').policyNumber }}</strong>
                          </vs-col>
                        </vs-row>
                      </vs-col>
                    </vs-row>
                  </vs-col>
                </vs-row>
                <vs-row class="mt-10">
                  <vs-col>
                    <div class="vx-card__title mb-6"><h4 class="">{{ $t('view_referral.block.information.action.title') }}</h4></div>
                  </vs-col>
                </vs-row>
                <vs-row>
                  <vs-col>
                    <vs-row>
                      <vs-col vs-lg="6" vs-sm="12" class="px-5 py-2">
                        <vs-row>
                          <vs-col vs-w="3">
                            <span>{{ $t('view_referral.block.information.action.fields.program') }}</span>
                          </vs-col>
                          <vs-col vs-w="9">
                            <strong>{{ referral.$getEmbedded('referral-action').$getEmbedded('access-code').name }}</strong>
                          </vs-col>
                        </vs-row>
                      </vs-col>
                      <vs-col vs-lg="6" vs-sm="12" class="px-5 py-2">
                        <vs-row>
                          <vs-col vs-w="3">
                            <span>{{ $t('view_referral.block.information.action.fields.lastDayAtWork') }}</span>
                          </vs-col>
                          <vs-col vs-w="9">
                            <strong>{{ referral.$getEmbedded('referral-claim').lastDayAtWork }}</strong>
                          </vs-col>
                        </vs-row>
                      </vs-col>
                    </vs-row>
                  </vs-col>
                </vs-row>

                <template v-if="trainingModule">
                  <vs-row class="mt-10">
                    <vs-col>
                      <div class="vx-card__title mb-6"><h4 class="">{{ $t('view_referral.block.information.training_assignment.title') }}</h4></div>
                    </vs-col>
                  </vs-row>
                  <vs-row>
                    <vs-col>
                      <vs-row>
                        <vs-col vs-lg="6" vs-sm="12" class="px-5 py-2">
                          <vs-row>
                            <vs-col vs-w="3">
                              <span>{{ $t('view_referral.block.information.training_assignment.fields.training.title') }}</span>
                            </vs-col>
                            <vs-col vs-w="9">
                              <strong>{{ trainingModule.productName }}</strong>
                            </vs-col>
                          </vs-row>
                        </vs-col>
                      </vs-row>
                    </vs-col>
                  </vs-row>
                </template>

                <template v-if="checkupCadence">
                  <vs-row class="mt-10">
                    <vs-col>
                      <div class="vx-card__title mb-6"><h4 class="">{{ $t('view_referral.block.information.checkup.title') }}</h4></div>
                    </vs-col>
                  </vs-row>
                  <vs-row>
                    <vs-col>
                      <vs-row>
                        <vs-col vs-lg="6" vs-sm="12" class="px-5 py-2">
                          <vs-row>
                            <vs-col vs-w="3">
                              <span>{{ $t('view_referral.block.information.checkup.fields.checkup_frequency') }}</span>
                            </vs-col>
                            <vs-col vs-w="9">
                              <strong>{{ checkupCadenceFrequencyLabel }}</strong>
                            </vs-col>
                          </vs-row>
                        </vs-col>
                        <vs-col vs-lg="6" vs-sm="12" class="px-5 py-2">
                          <vs-row>
                            <vs-col vs-w="3">
                              <span>{{ $t('view_referral.block.information.checkup.fields.checkup_amount') }}</span>
                            </vs-col>
                            <vs-col vs-w="9">
                              <strong>{{ checkupCadenceAmountLabel }}</strong>
                            </vs-col>
                          </vs-row>
                        </vs-col>
                      </vs-row>
                    </vs-col>
                  </vs-row>
                </template>

                <vs-row class="mt-10">
                  <vs-col>
                    <div class="vx-card__title mb-6"><h4 class="">{{ $t('view_referral.block.information.message.title') }}</h4></div>
                  </vs-col>
                </vs-row>
                <vs-row>
                  <vs-col>
                    <vs-row>
                      <vs-col vs-w="12" class="px-5 py-2">
                        <strong style="white-space: pre-wrap;">{{ referral.$getEmbedded('referral-action').message }}</strong>
                      </vs-col>
                    </vs-row>
                  </vs-col>
                </vs-row>
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col vs-w="12" class="px-5 py-2 text-center">

                <vs-button
                  v-if="referral.$hasLink('delete')"
                  class="mx-5 my-3" style="min-width: 200px;" size="large" color="danger" type="filled" @click="onDelete">
                  {{ $t('view_referral.buttons.delete') }}
                </vs-button>

                <vs-button
                  v-if="referral.$hasLink('preview')"
                  class="mx-5 my-3" style="min-width: 200px;" size="large" color="secondary" type="filled" @click="onViewEmail">
                  {{ $t('view_referral.buttons.view_email') }}
                </vs-button>

                <sm-interval-button
                  class="mx-5 my-3" style="min-width: 200px;" size="large" color="primary" type="filled"
                  v-if="referral.$hasLink('notify-claimant')"
                  :key="referral.$getEmbedded('referral-acceptance').lastSent"
                  :label="$t('view_referral.buttons.resend')"
                  :baseTime="referral.$getEmbedded('referral-acceptance').lastSent"
                  @click="onResend">
                </sm-interval-button>

                <vs-button class="mx-5 my-3" style="min-width: 200px;" size="large" color="primary" type="border" @click="onEdit"
                           v-if="referral.$hasLink('edit')">
                  {{ $t('view_referral.buttons.edit') }}
                </vs-button>

              </vs-col>
            </vs-row>
          </vx-card>
        </vs-col>
      </vs-row>
    </vs-col>
    <vs-col vs-w="3" class="pl-8">
      <vs-row>
        <vs-col>
          <vx-card :title="$t('view_referral.block.timeline.title')">
            <referral-timeline :referral-resource="referral"/>
          </vx-card>
        </vs-col>
      </vs-row>
    </vs-col>
    <vs-popup :active.sync="preview" fullscreen title="View Email" class-content="content-full">
      <referral-view-email v-if="preview" :referral-resource="referralResource"></referral-view-email>
    </vs-popup>
  </vs-row>
</template>

<script>
import SmIntervalButton from '@/components/starling/sm-interval-button/sm-interval-button';
import VxTimeline from '@/components/timeline/VxTimeline';
import preview from '@/views/app/send_referral/preview';
import ReferralTimeline from '@/views/app/view_referral/referral-timeline';
import ReferralViewEmail from '@/views/app/view_referral/referral-view-email';
import { ResourceImpl } from 'hal-client';
import flatPickr from 'vue-flatpickr-component';

export default {
  name: 'view-referral',
  components: {
    ReferralViewEmail,
    ReferralTimeline,
    VxTimeline,
    preview,
    flatPickr,
    SmIntervalButton
  },
  props: {
    referralResource: ResourceImpl
  },
  data () {
    return {
      userIdLabel: null,
      preview: false,
      referral: this.referralResource,
      behalfOf: null,
      behalfOfTitle: null,
      isCaseManagerTeamOn: null,
      hqTeamLabel: null,
      businessUnitLabel: null,
      policyNumberLabel: null,
      showPolicyNumberLabel: true,
      referralAssignments: null
    };
  },
  computed: {
    checkupCadence () {
      if (!this.referralAssignments || !this.referralAssignments.length) return null;
      return this.referralAssignments.find(assignment => assignment.type === 'CHECKUP_CADENCE');
    },
    checkupCadenceFrequencyLabel () {
      if (!this.checkupCadence) return;
      switch (this.checkupCadence.checkupFrequency) {
      case 1: return this.$t('view_referral.block.information.checkup.frequency_options.every_week');
      case 2: return this.$t('view_referral.block.information.checkup.frequency_options.two_weeks');
      case 3: return this.$t('view_referral.block.information.checkup.frequency_options.three_weeks');
      case 4: return this.$t('view_referral.block.information.checkup.frequency_options.four_weeks');
      default: return this.$t('view_referral.block.information.checkup.frequency_options.member_discretion');
      }
    },
    checkupCadenceAmountLabel () {
      if (!this.checkupCadence) return;
      if (!this.checkupCadence.checkupQuantityDue) {
        return this.$t('view_referral.block.information.checkup.amount_options.member_discretion');
      } else {
        return this.$t('view_referral.block.information.checkup.amount_options.qty_checkups', { qty: this.checkupCadence.checkupQuantityDue });
      }
    },
    trainingModule () {
      if (!this.referralAssignments || !this.referralAssignments.length) return null;
      return this.referralAssignments.find(assignment => assignment.type === 'MODULE');
    }
  },
  mounted () {
    this.isCaseManagerTeamOn = this.$store.state.router.profileResource.caseManagerTeamOn;
    this.referralResource.$request().$get('user-id-label', null, {locale: 'en'}).then((res) => {
      this.userIdLabel = res.state().label;
      if (!this.userIdLabel) {
        this.userIdLabel = this.$t('view_referral.block.information.claim.fields.claimNumber');
      }
    });
    this.referralResource.$request().$get('hq-team-label', null, {locale: 'en'}).then((res) => {
      this.isCaseManagerTeamOn = res.state().enabled;
      this.hqTeamLabel = res.state().label;
      if (!this.hqTeamLabel) {
        this.hqTeamLabel = this.$t('view_referral.block.information.action.fields.team');
      }
    });
    this.referralResource.$request().$get('business-unit-label', null, {locale: 'en'}).then((res) => {
      this.businessUnitLabel = res.businessLabel;
    });
    if (this.referralResource.behalfOf) {
      this.behalfOf = this.referralResource.behalfOf;
      this.behalfOfTitle = 'Referring on behalf of';
    } else if (this.referralResource.sentBy) {
      this.behalfOf = this.referralResource.sentBy;
      this.behalfOfTitle = 'Sent By';
    }
    this.referralResource.$request().$get('policy-number-label', null, {locale: 'en'}).then((res) => {
      this.policyNumberLabel = res.state().label;
      this.showPolicyNumberLabel = res.state().enabled;
      if (!this.policyNumberLabel) {
        this.policyNumberLabel = this.$t('view_referral.block.information.claim.fields.policyNumber');
      }
    });
    if (this.referralResource.$hasLink('referral-assignments')) {
      this.referralResource.$request().$get('referral-assignments').then((res) => {
        this.referralAssignments = res.$getEmbedded('referral-assignments');
      });
    }

  },
  methods: {
    onViewEmail () {
      this.preview = true;
    },
    onDelete () {
      const claimant = this.referral.$getEmbedded('referral-claimant');
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm',
        text: 'Are you sure you want to permanently delete the referral? This action cannot be reversed.',
        accept: () => {
          this.referral
            .$request()
            .$delete('delete')
            .then(() => {
              this.$vs.notify({
                title: 'Referral deleted',
                text: `The referral to claimant ${claimant.firstname} ${claimant.lastname} has been properly deleted.`,
                iconPack: 'feather',
                icon: 'icon-check-circle',
                color: 'success'
              });
              this.$router.push({
                name: 'app-view-referrals'
              });
            }, () => {
              this.$vs.notify({
                title: 'Referral is not deleted',
                text: `An error occured. The referral to claimant ${claimant.firstname} ${claimant.lastname} has not been deleted.`,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              });
            });
        }
      });
    },
    onResend () {
      const claimant = this.referral.$getEmbedded('referral-claimant');
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Resend referral',
        text: `Are you sure you want to re-send the notification to claimant ${claimant.firstname} ${claimant.lastname}?`,
        accept: () => {
          this.referral.$request().$post('notify-claimant').then(() => {
            this.referral.$request().$getSelf().then(res => {
              this.referral = res;
            });

            this.$vs.notify({
              title: 'Notification sent',
              text: `The claimant ${claimant.firstname} ${claimant.lastname} has been correctly notified.`,
              iconPack: 'feather',
              icon: 'icon-check-circle',
              color: 'success'
            });
          }, () => {
            this.$vs.notify({
              title: 'Notification not sent',
              text: `An error occured. The claimant ${claimant.firstname} ${claimant.lastname} has not been notified.`,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
          });
        }
      });
    },
    onEdit () {
      this.$router.push({
        name: 'app-edit-referral',
        params: {
          id: this.referral.id
        }
      });
    }
  }
};
</script>

<style>

.content-full {
  width: 100%;
  height: 100%;
}
</style>
